export default function TestimonialSection() {
  const testimonials = [
    {
      quote: 'The Kakobuy Spreadsheet completely changed how I shop. I used to spend hours searching for quality products, but now I can find verified sellers and trusted items in minutes. The weekly updates are a game-changer!',
      name: 'Alex M.',
      tag: 'Verified Buyer',
    },
    {
      quote: 'As someone new to spreadsheet shopping, the buying guides and safety tips on this site were invaluable. The QC inspection guide alone saved me from several bad purchases. Highly recommend the Kakobuy Spreadsheet.',
      name: 'Jordan K.',
      tag: 'Community Member',
    },
    {
      quote: 'I have been using the Kakobuy Spreadsheet for over six months now. The category organization is excellent, and the direct links to KaSpreadsheet make browsing effortless. Best resource hub out there.',
      name: 'Taylor R.',
      tag: 'Regular Shopper',
    },
  ];

  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left */}
          <div className="lg:w-[60%]">
            <div className="flex items-center gap-2 mb-8">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-foreground-500 text-sm font-medium uppercase tracking-wide">Verified Reviews</span>
            </div>

            <div className="space-y-12">
              {testimonials.map((t, idx) => (
                <div key={idx} className={idx > 0 ? 'border-t border-background-200 pt-10' : ''}>
                  <p className="text-foreground-950 text-xl md:text-2xl lg:text-3xl font-medium leading-relaxed mb-6">
                    &ldquo;{t.quote}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <span className="text-foreground-950 font-bold text-base">{t.name}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span className="text-accent-700 text-sm font-medium">{t.tag}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Image */}
          <div className="lg:w-[40%] flex items-start justify-center lg:justify-end">
            <div className="relative w-64 h-80 md:w-80 md:h-96 rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20stylish%20person%20in%20profile%20looking%20upward%20with%20confidence%2C%20shoulders%20up%20composition%2C%20soft%20dramatic%20side%20lighting%20on%20a%20clean%20warm%20beige%20studio%20background%2C%20contemporary%20fashion%20photography%2C%20minimal%20aesthetic%20with%20gentle%20shadow%20play%20and%20refined%20atmosphere&width=600&height=800&seq=testimonial-v2-030&orientation=portrait"
                alt="Kakobuy Spreadsheet Verified Buyer"
                title="Kakobuy Spreadsheet Community Member"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}